<template id="vuenavbar">
    <v-navigation-drawer
            app
            :mini-variant.sync="mini"
            v-model="drawer"
            permanent
            dark
    >
        <v-list>

            <v-list-item class="px-2">

                <v-list-item-avatar color="grey darken-2">
                    {{ avatar }}
                </v-list-item-avatar>

                <v-list-item-title>{{ $auth.user().name }}</v-list-item-title>

                <v-btn
                        icon
                        @click.stop="mini = !mini"
                >
                    <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
            </v-list-item>

        </v-list>

        <v-list dense>
            <v-list-item
                    v-for="item in items"
                    :key="item.title"
                    link
                    @click="r(item.to)"
            >
                <v-list-item-icon>
                    <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </v-list>

        <template v-slot:append>
            <div class="pa-2">
                <v-btn v-show="authCheck" v-on:click="logout()" id="logout_btn" block :class="mini ? 'px-0' : ''">
                    {{ mini ? "" : "Logout"}}
                    <v-icon :right="!mini" dark small>mdi-logout</v-icon>
                </v-btn>
            </div>
        </template>

    </v-navigation-drawer>
</template>

<script>
    export default {
        name: "Navigation",
        data () {
            return {
                drawer : true,
                mini: false,
                items:[]
            }
        },
        computed: {
            avatar(){
                if( this.$auth.user().name !== undefined ){
                    return this.$auth.user().name.substring(0, 2).toUpperCase();
                } else {
                    return '**';
                }
            },
            authCheck() {
                return this.$auth.check();
            }
        },
        methods: {
            r : function( to ){
                this.$router.push( { path: to } )
            },
            logout() {
                this.$auth.logout({
                    makeRequest: true, success: (response) => {
                        if (response.data.hasOwnProperty('redirect')) {
                            window.location.replace(response.data.redirect);
                        }
                    }, error: (res) => {
                        console.log(res);
                    },
                });
            },
        },
        created() {
            this.items = this.$router.options.routes.filter( (item) => {

                let canUse = item.hasOwnProperty('meta' ) && item.meta.hasOwnProperty('auth' ) && item.meta.auth.filter((r)=>{
                    return this.$auth.check(r);
                }).length > 0;

                return item.hasOwnProperty('props') && item.props.hasOwnProperty('nav') && canUse;

            } ).map( (item) => {
                return {
                    title: item.props.nav.hasOwnProperty( 'title' ) ? item.props.nav.title : '',
                    icon: item.props.nav.icon,
                    to: item.path,
                }
            });
        }
    }
</script>

<style>

</style>